import {PATHS} from "../../../../routing/paths";
import {CONTACT, SERVICE, type LegalDoc} from "./common";

/** Описание функциональных характеристик ПО (/functional-characteristics). */
export const FUNCTIONAL_CHARACTERISTICS_DOC: LegalDoc = {
    title: "Описание функциональных характеристик ПО",
    linkLabel: "описание функциональных характеристик ПО",
    path: PATHS.functionalCharacteristics,
    updated: "19 октября 2026 г.",
    sections: [
        {
            title: "1. Назначение программного обеспечения",
            body: [
                `Программное обеспечение ${SERVICE} (далее — ПО) представляет собой веб-приложение и мобильное приложение для знакомств, использующее искусственный интеллект для подбора совместимых анкет.`,
                "ПО предназначено для поиска романтических партнёров и друзей на основе совместимости интересов, ценностей и психологических характеристик. Сервис объединяет традиционный подход к знакомствам с современными AI-технологиями.",
            ],
        },
        {
            title: "2. Регистрация и авторизация",
            body: [
                "Регистрация осуществляется по адресу электронной почты или через номер телефона с подтверждением по одноразовому коду (OTP).",
                "Доступна авторизация по паролю или по одноразовому коду на зарегистрированный email/телефон.",
                "Поддерживается автоматическая сессия после первого входа (JWT-токен) с возможностью выхода из учётной записи.",
                "Восстановление пароля реализовано через отправку ссылки или кода на адрес электронной почты.",
            ],
        },
        {
            title: "3. Профиль и анкета пользователя",
            body: [
                "Пользователь создаёт анкету, указывая: имя, дату рождения, пол, город проживания. Дополнительно можно загрузить до 6 фотографий.",
                "Поддерживается заполнение расширенной анкеты: рост, образование, профессия, интересы и хобби, образ жизни, отношение к курению/алкоголю, знак зодиака.",
                "Возможен выбор целей знакомства: серьёзные отношения, дружба, общение, совместный досуг.",
                "Профиль можно скрыть из ленты (настройка «Приватный профиль»), доступно всем пользователям.",
            ],
        },
        {
            title: "4. Онбординг и тест совместимости",
            body: [
                "После регистрации пользователь проходит короткий онбординг (до 10 вопросов) для определения ценностей, предпочтений и стиля общения.",
                "На основе онбординга рассчитывается AI-профиль совместимости пользователя.",
                "Онбординг можно пропустить, но полнота анкеты влияет на качество подбора.",
            ],
        },
        {
            title: "5. Просмотр анкет и механика «лайков»",
            body: [
                "Анкеты отображаются в ленте в формате «свайп-карточек»: можно поставить «лайк» (👍) или «пропуск» (👎).",
                "Лайки бесплатны и не ограничены для всех пользователей.",
                "Супер симпатии позволяют выделиться перед собеседником: такая анкета гарантированно показывается выделенной.",
                "Приоритетный показ — Premium-анкеты получают бо́льшую видимость в ленте других пользователей.",
            ],
        },
        {
            title: "6. Мэтчинг и AI-подбор",
            body: [
                "AI-матчинг анализирует данные анкеты, ответы онбординга и поведение в сервисе (история лайков, пропусков) для расчёта релевантности каждой пары.",
                "Дополнительно рассчитываются астрологическая и нумерологическая совместимость по датам рождения (развлекательные алгоритмы).",
                "При совпадении взаимных лайков образуется «мэтч», и у пользователей открывается доступ к чату.",
                "Рекомендации обновляются ежедневно с учётом новых данных.",
            ],
        },
        {
            title: "7. Чаты и общение",
            body: [
                "Чат-интерфейс с поддержкой текстовых сообщений, эмодзи, изображений и виртуальных подарков.",
                "AI-помощник (чат-бот) подсказывает темы для начала разговора, анализирует контекст переписки и предлагает релевантные вопросы или комплименты.",
                "Поддерживаются голосовые заметки (iOS/Android).",
                "В чате доступна кнопка «Пожаловаться» с выбором причины жалобы.",
            ],
        },
        {
            title: "8. Верификация и безопасность",
            body: [
                "Строка «Верифицировать аккаунт» в профиле (со статусом в подзаголовке) открывает отдельную страницу: привязка и статус способов входа Yandex ID, VK ID и email (email подтверждается кодом из письма); аккаунт провайдера, уже привязанный к другому профилю, не привязывается и не сливается.",
                "Верификация анкеты: загрузка паспорта для подтверждения личности (модератор вручную проверяет в течение 24 часов).",
                "Автоматическая модерация фото на основе AI: блокировка непристойных, оскорбительных или несоответствующих правилам изображений.",
                "Жалобы на пользователей обрабатываются модераторами сервиса в течение 12 часов.",
                "Поддерживается чёрный список (блокировка нежелательных пользователей); заблокированный не может писать сообщения и видеть анкету.",
            ],
        },
        {
            title: "9. Подписки и платежи",
            body: [
                "Premium-подписка — разовая покупка без автопродления: 1 месяц — 990 ₽ (30 дней), 3 месяца — 1990 ₽ (90 дней), 6 месяцев — 2990 ₽ (180 дней). Продление — повторная покупка, срок прибавляется к текущему.",
                "Premium даёт: просмотр анкет тех, кто лайкнул пользователя; безлимитный возврат к предыдущей карточке (без подписки — 5 на аккаунт); 15 супер симпатий на каждые 30 дней подписки (неиспользованные сгорают в конце периода); приоритетный показ в ленте.",
                "Супер симпатии — пакеты по 5, 10, 50 штук; купленные и стартовые (5 при регистрации) хранятся на балансе и не сгорают.",
                "ИИ-разбор совместимости — покупается отдельно (разовый разбор или пакет разборов), в подписку не входит.",
                "Виртуальные подарки: стикеры, анимационные открытки, возможность отправить реальный подарок (интеграция).",
                "Все платежи обрабатываются через защищённого платёжного провайдера, данные карт не хранятся на серверах сервиса.",
            ],
        },
        {
            title: "10. QR-коды и приглашения",
            body: [
                "Для каждого пользователя генерируется уникальный QR-код, позволяющий добавить анкету в избранное одним сканированием.",
                "Ссылка-приглашение для передачи анкеты друзьям и размещения в соцсетях.",
                "Гостевой доступ по ссылке-приглашению — просмотр анкеты без регистрации (с ограничением функций).",
            ],
        },
        {
            title: "11. Куда сходить (гео-рекомендации)",
            body: [
                "Интеграция с картами и каталогом заведений (кафе, рестораны, парки, музеи, кинотеатры) для предложения мест для свиданий.",
                "Фильтрация по типу заведения, цене, отзывам, дистанции от текущего местоположения или метро.",
                "Возможность отправить выбранное место собеседнику в чат как предложение для встречи.",
            ],
        },
        {
            title: "12. Уведомления",
            body: [
                "Push-уведомления (мобильные) и email-уведомления о новых мэтчах, сообщениях, лайках, событиях в сервисе.",
                "Настройка типов уведомлений в профиле пользователя: можно отключить отдельные категории или все уведомления.",
            ],
        },
        {
            title: "13. Технические характеристики",
            body: [
                "Веб-версия: поддерживаются современные версии браузеров Chrome, Firefox, Safari, Edge.",
                "Мобильное приложение: Android 8.0+, iOS 15.0+.",
                "Клиент-серверная архитектура с REST API и WebSocket для чатов в реальном времени.",
                "Требуется постоянное подключение к сети Интернет (3G/4G/5G/Wi-Fi). Для использования гео-функций необходимо разрешение геолокации."
            ],
        },
    ],
};